import Vue from 'vue'
import Vuex from 'vuex'
import ajax from '@/api/request'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		userinfo: {
			has: '', // 是否已登录
			name: '', // 昵称
			head: '', // 头像
			phonecode: '', // 区号
			phone: '', // 手机号码
			company: '', // 单位名称
			person: '', // 注册人名称
			spa: '', // spa编码
		},
		noticeNoread: 0, // 消息未读数
		shopcarNum: 0, // 购物车数量(商品数)
		shopcarAllNum: 0, // 购物车总数量(商品总数)
	},
	mutations: {
		setUserinfo(state,data){
			state.userinfo.has = (data.token!=undefined)
			state.userinfo.name = data.nickname||''
			state.userinfo.head = data.avatar||require('../assets/img/head.jpg')
			state.userinfo.phonecode = data.prefix||''
			state.userinfo.phone = data.mobile||''
			state.userinfo.company = data.enterprise_name||''
			state.userinfo.person = data.register_name||''
			state.userinfo.spa = data.spa_code||''
		},
		setNoticeNoread(state,data){
			state.noticeNoread = data||0
		},
		updateShopcar(state,data){
			if(data!=undefined){
				state.shopcarNum = data.count
				state.shopcarAllNum = data.count2
				return
			}
			ajax.getShopcar().then(r=>{
				state.shopcarNum = r.goods_list.length
				state.shopcarAllNum = r.order_total_num
			})
		},
	},
})

if(window.localStorage.getItem('usertoken')){
	// 初始化获取用户信息
	ajax.getUserInfo({
		try: true,
	}).then(r=>{
		store.commit('setUserinfo',r)
	})
	
	// 每5秒获取消息未读数
	ajax.getNoticeNoread({
		try: true,
	}).then(r=>{
		store.commit('setNoticeNoread',r.no_read_message_count||0)
	})
	setInterval(()=>{
		ajax.getNoticeNoread({
			try: true,
		}).then(r=>{
			store.commit('setNoticeNoread',r.no_read_message_count||0)
		})
	},10000)
	
	// 获取初始化购物车数据
	store.commit('updateShopcar')
}

export default store


// WEBPACK FOOTER //
// ./src/store/index.js